export default __webpack_public_path__ + "static/media/Spectrum-Tokens-ObjectStyles.5eec7091.png";